import Alpine from "alpinejs";
import AsyncAlpine from "async-alpine";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import lightbox from 'alpine-tailwind-lightbox'
import validate from '@colinaut/alpinejs-plugin-simple-validate'

import slider from "./components/slider";
import form from "./components/form";
import navIndicator from "./components/nav-indicator";
import downloadGate from "./components/download-gate";
import siteHeader from "./components/site-header";
import registerModalStore from "./stores/modal";
import registerConsentStore from "./stores/consent";

document.documentElement.classList.remove("loading");

Alpine.plugin(AsyncAlpine);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(lightbox);
Alpine.plugin(validate);

// alpine-tailwind-lightbox stores its items in a long-lived Alpine store
// and renders the lightbox `<div>` straight onto <body>. Both survive Swup
// page navigations, so galleries accumulate across pages. Extend the store
// with a reset() so the navigation hook can wipe items between visits.
Alpine.store("lightbox").reset = function () {
  for (const group in this.items) this.items[group] = [];
  for (const group in this.show) this.show[group] = null;
};

Alpine.magic('cssVar', () => {
  return (name) => parseInt(getComputedStyle(document.documentElement).getPropertyValue(name));
});

Alpine.store("menuOpen", false);
Alpine.store("searchOpen", false);
Alpine.store("currentSite", "default");
registerModalStore(Alpine);
registerConsentStore(Alpine);

// Re-apply consent state on every page load (for returning visitors)
document.addEventListener("alpine:initialized", () => {
  const gaId = document.documentElement.dataset.gaId || null;
  Alpine.store("consent").hydrate(gaId);
});

Alpine.data('slider', slider)
Alpine.data('form', form)
Alpine.data('navIndicator', navIndicator)
Alpine.data('downloadGate', downloadGate)
Alpine.data('siteHeader', siteHeader)

window.Alpine = Alpine;
Alpine.start();
